import {
  FETCH_LOGIN_DETAILS,
  FETCH_LOGIN_DETAILS_SUCCESS,
  FETCH_LOGIN_DETAILS_FAILURE,
  FETCH_UNREGISTERED_EMPLOYEES,
  FETCH_UNREGISTERED_EMPLOYEES_SUCCESS,
  FETCH_UNREGISTERED_EMPLOYEES_FAILURE,
  CREATE_LOGIN_USER_REQUEST,
  CREATE_LOGIN_USER_SUCCESS,
  CREATE_LOGIN_USER_FAILURE,
  RESET_PASSWORD_REQUEST, 
  RESET_PASSWORD_SUCCESS, 
  RESET_PASSWORD_FAILURE,
  TOGGLE_USER_STATUS_REQUEST,
  TOGGLE_USER_STATUS_SUCCESS,
  TOGGLE_USER_STATUS_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  FETCH_ROLES_REQUEST,
  FETCH_ACCESS_RIGHTS_REQUEST,
  SAVE_ROLE_ACCESS_RIGHTS_REQUEST,
  FETCH_MODULES_REQUEST,
  SAVE_MODULE_REQUEST,
  DELETE_MODULE_REQUEST,
  FETCH_CONFIGURATION_SETUP_REQUEST,
  SAVE_CONFIGURATION_SETUP_REQUEST,
} from "./actionTypes";

// Fetch Login Details
export const fetchLoginDetails = (unitId) => ({
  type: FETCH_LOGIN_DETAILS,
  payload: { unitId }
});

export const fetchLoginDetailsSuccess = (loginDetails) => ({
  type: FETCH_LOGIN_DETAILS_SUCCESS,
  payload: loginDetails,
});

export const fetchLoginDetailsFailure = (error) => ({
  type: FETCH_LOGIN_DETAILS_FAILURE,
  payload: error,
});

// Fetch Unregistered Employees
export const fetchUnregisteredEmployees = (unitId) => ({
  type: FETCH_UNREGISTERED_EMPLOYEES,
  payload: { unitId }
});

export const fetchUnregisteredEmployeesSuccess = (employeeList) => ({
  type: FETCH_UNREGISTERED_EMPLOYEES_SUCCESS,
  payload: employeeList,
});

export const fetchUnregisteredEmployeesFailure = (error) => ({
  type: FETCH_UNREGISTERED_EMPLOYEES_FAILURE,
  payload: error,
});

// Action to create login user
export const createLoginUserRequest = (userData) => ({
  type: CREATE_LOGIN_USER_REQUEST,
  payload: userData,
});

export const createLoginUserSuccess = (response) => ({
  type: CREATE_LOGIN_USER_SUCCESS,
  payload: response,
});

export const createLoginUserFailure = (error) => ({
  type: CREATE_LOGIN_USER_FAILURE,
  payload: error,
});


// Reset Password
export const resetPasswordRequest = (resetData) => ({
  type: RESET_PASSWORD_REQUEST,
  payload: resetData
});

export const resetPasswordSuccess = (message) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: message
});

export const resetPasswordFailure = (error) => ({
  type: RESET_PASSWORD_FAILURE,
  payload: error
});

export const toggleUserStatusRequest = (changeStatus) => ({
  type: TOGGLE_USER_STATUS_REQUEST,
  payload: changeStatus
});

export const toggleUserStatusSuccess = (message) => ({
  type: TOGGLE_USER_STATUS_SUCCESS,
  payload: message
});

export const toggleUserStatusFailure = (error) => ({
  type: TOGGLE_USER_STATUS_FAILURE,
  payload: error
});

export const changePasswordRequest = (formData) => ({
  type: CHANGE_PASSWORD_REQUEST,
  payload: formData,
});

export const changePasswordSuccess = (message) => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload: message,
});

export const changePasswordFailure = (error) => ({
  type: CHANGE_PASSWORD_FAILURE,
  payload: error,
});

export const fetchAccountRoles = (unitId) => ({
  type: FETCH_ROLES_REQUEST,
  payload: {unitId},
});

export const fetchRolesAccessRights = (roleId) => ({
  type: FETCH_ACCESS_RIGHTS_REQUEST,
  payload: {roleId},
});

export const saveRoleAccessRights = (payload) => ({
  type: SAVE_ROLE_ACCESS_RIGHTS_REQUEST,
  payload,
});

export const fetchModules = (unitId) => ({
  type: FETCH_MODULES_REQUEST,
  payload: { unitId },
});

export const saveApplicationModuleDetails = (data) => ({
  type: SAVE_MODULE_REQUEST,
  payload: data,
});

export const deleteModule = (payload) => ({
  type: DELETE_MODULE_REQUEST,
  payload,
});

export const fetchConfigurationSetup = (unitId) => ({
  type: FETCH_CONFIGURATION_SETUP_REQUEST,
  payload: { unitId },
});

export const saveConfigurationSetup = (data) => ({
  type: SAVE_CONFIGURATION_SETUP_REQUEST,
  payload: data,
});